// package: common
// file: grpc-models/Common.proto

var grpc_models_Common_pb = require("../grpc-models/Common_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var CommonProtoService = (function () {
  function CommonProtoService() {}
  CommonProtoService.serviceName = "common.CommonProtoService";
  return CommonProtoService;
}());

CommonProtoService.GetPackageStatus = {
  methodName: "GetPackageStatus",
  service: CommonProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Common_pb.GetPackageStatusRequest,
  responseType: grpc_models_Common_pb.GetPackageStatusResponse
};

CommonProtoService.EstimateGenerationCredits = {
  methodName: "EstimateGenerationCredits",
  service: CommonProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Common_pb.EstimateGenerationCreditsRequest,
  responseType: grpc_models_Common_pb.EstimateGenerationCreditsResponse
};

CommonProtoService.CheckTokenExpiry = {
  methodName: "CheckTokenExpiry",
  service: CommonProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Common_pb.CheckTokenExpiryRequest,
  responseType: grpc_models_Common_pb.CheckTokenExpiryResponse
};

CommonProtoService.GetBusinessSettings = {
  methodName: "GetBusinessSettings",
  service: CommonProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Common_pb.GetBusinessSettingsRequest,
  responseType: grpc_models_Common_pb.GetBusinessSettingsResponse
};

CommonProtoService.GetUserProfile = {
  methodName: "GetUserProfile",
  service: CommonProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Common_pb.GetUserProfileRequest,
  responseType: grpc_models_Common_pb.GetUserProfileResponse
};

CommonProtoService.GetBusinessOnboardingDetails = {
  methodName: "GetBusinessOnboardingDetails",
  service: CommonProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Common_pb.GetBusinessOnboardingDetailsRequest,
  responseType: grpc_models_Common_pb.GetBusinessOnboardingDetailsResponse
};

CommonProtoService.GetBusinessIntegrationSettings = {
  methodName: "GetBusinessIntegrationSettings",
  service: CommonProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Common_pb.GetBusinessIntegrationSettingsRequest,
  responseType: grpc_models_Common_pb.GetBusinessIntegrationSettingsResponse
};

CommonProtoService.GetFacebookAdAccountStatus = {
  methodName: "GetFacebookAdAccountStatus",
  service: CommonProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Common_pb.GetFacebookAdAccountStatusRequest,
  responseType: grpc_models_Common_pb.GetFacebookAdAccountStatusResponse
};

CommonProtoService.GetMetaIntegrationStatus = {
  methodName: "GetMetaIntegrationStatus",
  service: CommonProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Common_pb.GetMetaIntegrationStatusRequest,
  responseType: grpc_models_Common_pb.GetMetaIntegrationStatusResponse
};

CommonProtoService.GetIsCouponFeatureEnabled = {
  methodName: "GetIsCouponFeatureEnabled",
  service: CommonProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Common_pb.GetIsCouponFeatureEnabledRequest,
  responseType: grpc_models_Common_pb.GetIsCouponFeatureEnabledResponse
};

exports.CommonProtoService = CommonProtoService;

function CommonProtoServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

CommonProtoServiceClient.prototype.getPackageStatus = function getPackageStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(CommonProtoService.GetPackageStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CommonProtoServiceClient.prototype.estimateGenerationCredits = function estimateGenerationCredits(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(CommonProtoService.EstimateGenerationCredits, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CommonProtoServiceClient.prototype.checkTokenExpiry = function checkTokenExpiry(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(CommonProtoService.CheckTokenExpiry, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CommonProtoServiceClient.prototype.getBusinessSettings = function getBusinessSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(CommonProtoService.GetBusinessSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CommonProtoServiceClient.prototype.getUserProfile = function getUserProfile(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(CommonProtoService.GetUserProfile, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CommonProtoServiceClient.prototype.getBusinessOnboardingDetails = function getBusinessOnboardingDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(CommonProtoService.GetBusinessOnboardingDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CommonProtoServiceClient.prototype.getBusinessIntegrationSettings = function getBusinessIntegrationSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(CommonProtoService.GetBusinessIntegrationSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CommonProtoServiceClient.prototype.getFacebookAdAccountStatus = function getFacebookAdAccountStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(CommonProtoService.GetFacebookAdAccountStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CommonProtoServiceClient.prototype.getMetaIntegrationStatus = function getMetaIntegrationStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(CommonProtoService.GetMetaIntegrationStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CommonProtoServiceClient.prototype.getIsCouponFeatureEnabled = function getIsCouponFeatureEnabled(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(CommonProtoService.GetIsCouponFeatureEnabled, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.CommonProtoServiceClient = CommonProtoServiceClient;

